"use strict";
const DOM = {
		overviewBox: document.querySelectorAll(".overview-box-bottom"),
		productDetailsContent: document.querySelector(".product-details-content"),
		productDetailsLinks: document.querySelector(".product-details-links"),
		detailsFAQ: document.querySelector(".details-faq"),
		productVideo: document.querySelector(".product-video video"),
		productVideoSection: document.querySelector(".product-video"),
		productVideoBtn: document.querySelector(".product-video-btn"),
		contactForm: document.querySelector(".contact-page form")
	},
	openProductBox = function(e) {
		const t = e.getAttribute("href");
		document.querySelector(t) && (document.querySelector(".product-box.show") && document.querySelector(".product-box.show").classList.remove("show"), document.querySelector(t).classList.add("show"), document.querySelector(`${t} .product-box-close`).addEventListener("click", function() {
			document.querySelector(t).classList.remove("show")
		}), $(".product-cta").length && stickyProductBox($(".product-cta")))
	},
	hideProductBox = function(e) {
		const t = e.getAttribute("href");
		document.querySelector(t) && document.querySelector(".product-box.show") && document.querySelector(".product-box.show").classList.remove("show")
	},
	stickyProductBox = function(e) {
		const t = $(window).width() > 767 ? 80 : 15;
		e.position().top - $("header").height() < $(window).scrollTop() && $(window).scrollTop() < e.position().top + (e.height() - $(".product-box.show").height() + t) ? (e.find(".product-box.show").addClass("sticky"), e.find(".product-box.show").removeClass("bottom"), e.find(".product-box.show").attr("style", `top: ${$("header").height()+68}px;`)) : $(window).scrollTop() >= e.position().top + (e.height() - $(".product-box.show").height() + t) ? (e.find(".product-box.show").addClass("bottom"), e.find(".product-box.show").attr("style", "")) : (e.find(".product-box.show").removeClass("sticky"), e.find(".product-box.show").removeClass("bottom"), e.find(".product-box.show").attr("style", ""))
	};
DOM.overviewBox && DOM.overviewBox.forEach(function(e) {
	e.addEventListener("mouseover", function(e) {
		e.preventDefault();
		/*const t = e.target.closest(".overview-info");
		t && openProductBox(t)*/
	}), e.addEventListener("mouseout", function(e) {
		e.preventDefault();
		/*const t = e.target.closest(".overview-info");
		t && hideProductBox(t)*/
	})
}), DOM.productDetailsContent && DOM.productDetailsContent.addEventListener("mouseover", function(e) {
	e.preventDefault();
	const t = e.target.closest(".details-info");
	t && openProductBox(t)
}), DOM.productDetailsContent && DOM.productDetailsContent.addEventListener("mouseout", function(e) {
	e.preventDefault();
	const t = e.target.closest(".details-info");
	t && hideProductBox(t)
}), document.querySelector(".product-details-pane") && document.querySelector(".product-details-pane").classList.add("active"), document.querySelector(".product-details-link") && document.querySelector(".product-details-link").classList.add("active"), DOM.productDetailsLinks && DOM.productDetailsLinks.addEventListener("click", function(e) {
	e.preventDefault();
	const t = e.target.closest(".product-details-link");
	if (t && !t.classList.contains("active")) {
		e.preventDefault();
		const o = t.hash;
		document.querySelector(".product-details-link.active").classList.remove("active"), document.querySelector(`.product-details-link[href="${o}"]`).classList.add("active"), $(".product-details-pane.active").fadeOut(400, function() {
			document.querySelector(".product-details-pane.active").classList.remove("active"), $(`.product-details-pane${o}`).fadeIn(400, function() {
				document.querySelector(`.product-details-pane${o}`).classList.add("active")
			})
		})
	}
}), DOM.detailsFAQ && DOM.detailsFAQ.addEventListener("click", function(e) {
	e.preventDefault();
	const t = e.target.closest(".details-faq-link");
	if (t) {
		const e = $(t).parent().hasClass("active");
		$(".details-faq-link").parent().removeClass("active"), $(".details-faq-link").parent().find(".faq-pane").slideUp(), e || ($(t).parent().toggleClass("active"), $(t).parent().find(".faq-pane").slideToggle())
	}
}), DOM.contactForm && $(DOM.contactForm).validate({
	rules: {
		"contact[email]": {
			required: !0,
			email: !0
		},
		"contact[Name]": {
			required: !0
		},
		"contact[Last name]": {
			required: !0
		},
		"contact[Comment]": {
			required: !0
		}
	},
	messages: {
		"contact[email]": "Please enter a valid email address.",
		"contact[Name]": "This field is required.",
		"contact[Last name]": "This field is required.",
		"contact[Comment]": "This field is required."
	}
}), $("body").on("click", function(e) {
	$(e.target).closest(".product-submenu").length && !$(e.target).closest(".product-submenu-close") || $(e.target).closest(".product-nav-item").length || ( /*$(".product-nav-item.active").removeClass("active"),*/ $(".product-submenu").slideUp())
}), $(".product-nav-item").on("click", function(e) { /*e.preventDefault(),*/
	$(this).hasClass("active") || ( /*$(".product-nav-item.active").removeClass("active"),*/ $(".product-submenu").slideUp(), $(this).addClass("active"), $(this).parent().find(".product-submenu").slideDown())
}), $(".toggle-btn").on("click", function(e) {
	$(this).toggleClass("open"), $(".nav").slideToggle(), $("body").toggleClass("prevent-scroll")
});
const videoSections = document.querySelectorAll(".has-video");
videoSections.forEach(function(e) {
	const t = e.querySelector(".video-btn"),
		o = e.querySelector("video");
	t && t.addEventListener("click", function(t) {
		t.preventDefault(), o.play(), e.classList.add("playing")
	}), o && o.addEventListener("click", function() {
		e.classList.contains("playing") && (o.pause(), e.classList.remove("playing"))
	}), o && o.addEventListener("ended", function() {
		e.classList.remove("playing")
	}, !1)
}), $(function() {
	if ($(".overview-slider").length) {
		const e = {
			dots: !1,
			infinite: !1,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: !1,
			arrows: !0,
			asNavFor: ".overview-slider-nav .product__media-list",
            responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 1.2
				}
			}]
		};
		let t = $(".overview-slider .product__media-list").slick(e);
		const o = {
			slidesToShow: 5.5,
			slidesToScroll: 1,
			infinite: !1,
			asNavFor: ".overview-slider .product__media-list",
			dots: !1,
			focusOnSelect: !0,
			swipeToSlide: 1,
			responsive: [{
				breakpoint: 992,
				settings: {
                    arrows: 0
				}
			}]
		};
		let n = $(".overview-slider-nav .product__media-list").slick(o);
		$(".overview-slider-nav .product__media-item").length < 7 && $(window).width() > 767 && $(".overview-slider-nav .slick-track").addClass("disable"), $(".overview-slider-nav .product__media-item").length < 5 && $(window).width() < 768 && $(window).width() > 480 && $(".overview-slider-nav .slick-track").addClass("disable"), $(".overview-slider-nav .product__media-item").length < 4 && $(window).width() < 481 && $(".overview-slider-nav .slick-track").addClass("disable"), $(".overview .product-form__input select").on("change", function() {
			t.slick("unslick"), t = $(".overview-slider .product__media-list").slick(e), n.slick("unslick"), setTimeout(function() {
				n = $(".overview-slider-nav .product__media-list").slick(o), $(".overview-slider-nav .product__media-item").length < 7 && $(window).width() > 767 && $(".overview-slider-nav .slick-track").addClass("disable"), $(".overview-slider-nav .product__media-item").length < 5 && $(window).width() < 768 && $(window).width() > 480 && $(".overview-slider-nav .slick-track").addClass("disable"), $(".overview-slider-nav .product__media-item").length < 4 && $(window).width() < 481 && $(".overview-slider-nav .slick-track").addClass("disable")
			}, 100)
		});
      //carousel counter
        /*var $status = $('.overview-slider-counter span');
		var $slickElement = $('.overview-slider');
		let total = document.querySelectorAll('.overview-slider .product__media-item').length;
		$status.text('1' + '/' + total);
		$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
			var i = (currentSlide ? currentSlide : 0) + 1;
			$status.text(i + '/' + slick.slideCount);
		});*/
	}
	if ($(".alternating-blocks").length && $(window).width() > 991 && $(".alternating-blocks .block-col").matchHeight({
			byRow: !1
		}), $(".shopify-currency-form select").select2({
			minimumResultsForSearch: 1 / 0
		}), $(".shopify-currency-form select").on("select2:select", function(e) {
			$(".shopify-currency-form select").val(e.target.value), e.target.form.submit()
		}), $(".testimonials-slider").length) {
		const e = {
			method: "POST",
			headers: {
				accept: "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				grant_type: "client_credentials",
				client_id: "K1o6Ckkvu8OUbNXj8id8XS65tvDrxUb4tXnsGK2c",
				client_secret: "zyTf58J0xiOtIg9bECtrSwp4d5qjFzER32ItnKcZ"
			})
		};
		fetch("https://api.yotpo.com/oauth/token", e).then(e => e.json()).then(function(e) {
			const t = e.access_token;
			fetch("https://api.yotpo.com/v1/apps/K1o6Ckkvu8OUbNXj8id8XS65tvDrxUb4tXnsGK2c/reviews?utoken=" + t, {
				method: "GET",
				headers: {
					accept: "application/json",
					"Content-Type": "application/json"
				}
			}).then(e => e.json()).then(function(e) {
				const t = e.reviews,
					o = document.querySelector(".icon-fire").src,
					n = document.querySelector(".icon-knife").src;
				document.querySelector(".icon-axe").src, document.querySelector(".icon-olive-wood").src;
				console.log("Reviews 2", t);
				let i = "";
				t.forEach(function(e, s) {
					fetch(`/search/suggest.json?q=id:${e.sku}&resources[type]=product&limit=1`).then(e => e.json()).then(function(t) {
						t.resources.results.products.shift();
						let s, c = "",
							r = "";
						for (s = 0; s < e.score; s++) c += `<img src="${o}" alt="Icon fire">`;
						i += `\n                    <div class="testimonial">\n                      <div class="testimonial-content">\n                        <img src="${r=n}" alt="Review Product Icon">\n                        <div class="testimonial-rating">${c}</div>\n                        <div class="testimonial-comment">\n                          <p>${e.content}</p>\n                        </div>\n                        <p class="testimonial-author">${e.name}</p>\n                      </div>\n                    </div>\n                  `
					}).then(e => {
						t.length === s + 1 && (document.querySelector(".testimonials-slider").insertAdjacentHTML("beforeend", i), $(".testimonials-slider").slick({
							dots: !1,
							infinite: !0,
							speed: 300,
							slidesToShow: 3,
							autoplay: !0,
							autoplaySpeed: 2e3,
							arrows: !1,
							responsive: [{
								breakpoint: 767,
								settings: {
									slidesToShow: 1,
									arrows: !0
								}
							}]
						}))
					})
				})
			}).catch(e => console.error(e))
		}).catch(e => console.error(e))
	}
	if (document.querySelector("#yeps")) {
		var e = new CSSStyleSheet;
		e.replaceSync("\n      .yeps-bar {\n        background: #342F2F;\n        position: relative;\n        overflow: hidden;\n      }\n      .yeps-bar::after {\n        content: '';\n        background: radial-gradient(50% 50% at 50% 50%, #EE942A 0%, rgba(241, 79, 35, 0.838542) 29.69%, rgba(254, 0, 0, 0) 100%);\n        opacity: 0.8;\n        filter: blur(10px);\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: 872px;\n        height: 110px;\n      }\n      .yeps-bar.yeps-small .yeps-content {\n        text-align: center;\n        padding: 9px 35px 8px 8px;\n        font-size: 15px;\n      }\n      .yeps-text {\n        font-style: normal;\n        font-weight: 500;\n        font-size: 15px;\n        line-height: 20px;\n        color: $white;\n        text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.45);\n        padding: 0;\n        margin: 0;\n      }\n      @media screen and (max-width: 767px) {\n        .yeps-bar::after {\n          width: 246px;\n        }\n        .yeps-bar.yeps-small .yeps-content {\n          font-size: 13px;\n        }\n        .yeps-text {\n          font-size: 13px;\n        }\n      }\n    "), document.querySelector("#yeps").shadowRoot.adoptedStyleSheets = [e]
	}
	if ($("#Cart-note").length && $("#Cart-note").keyup(function() {
			const e = $(this).val().length;
			$("#char-limit").text(e)
		}), window.onscroll = function(e) {
			$(".product-cta").length && stickyProductBox($(".product-cta"))
		}, $(".cart-items").length) {
		let e = !0;
		$(".cart-items").on("click", function(t) {
			if ($(t.target).closest(".variant-selector")) {
				const o = $(t.target).closest(".variant-selector").attr("data-id");
				o && e && (e = !1, $.ajax({
					type: "POST",
					url: "/cart/add.js",
					dataType: "json",
					data: {
						id: o,
						quantity: 1
					},
					success: function() {
						location.href = "/cart"
					}
				}))
			}
		})
	}
});